module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.large) ? _c('v-list', [_vm._t("prefix"), _vm._l((_vm.options), function(player) {
    return _c('v-list-tile', {
      key: player.id,
      staticClass: "large-player",
      attrs: {
        "align-center": "",
        "px-3": "",
        "py-2": ""
      }
    }, [_c('v-list-tile-action', [_vm._t("icon", null, {
      player: player
    })], 2), _c('v-list-tile-title', [_c('span', {
      staticClass: "player-name"
    }, [_vm._v(_vm._s(player.name))])])], 1)
  }), _vm._t("postfix")], 2) : _c('v-layout', {
    attrs: {
      "wrap": "",
      "align-start": "",
      "align-content-start": ""
    }
  }, _vm._l((_vm.options), function(player) {
    return _c('v-layout', {
      key: player.id,
      staticClass: "player",
      attrs: {
        "align-center": "",
        "px-3": "",
        "py-2": ""
      }
    }, [_vm._t("icon", null, {
      player: player
    }), _c('span', {
      staticClass: "player-name ml-3"
    }, [_vm._v(_vm._s(player.name))])], 2)
  }))
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-0ce5111b","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"preserveWhitespace":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src.common/ui/players/list.vue
// module id = 311
// module chunks = 0